import { useNavigate, useSearchParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { motion } from 'framer-motion'
import {CheckCircle} from 'lucide-react'
import BlocoApresentacaoConsultora from '@/components/BlocoApresentacaoConsultora'
import { lumi } from '@/lib/lumi'
import { dispararMetaPageView } from '@/utils/metaPixel'
import AvisoCookiesMonica from '@/components/AvisoCookiesMonica'

function Home2() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [exibirOleosResultado, setExibirOleosResultado] = useState(false)

  const cParam = searchParams.get('c')

  // SE não há ?c= → redirecionar para /assinar
  useEffect(() => {
    if (!cParam) {
      navigate('/assinar', { replace: true })
    }
  }, [cParam, navigate])

  // Capturar parâmetro ?c= e armazenar no sessionStorage
  useEffect(() => {
    if (cParam) {
      sessionStorage.setItem('consultora_param', cParam.toLowerCase().trim())
      dispararMetaPageView(cParam, 'home-diagnostico')
    }
  }, [cParam])

  useEffect(() => {
    const slug = (cParam || '').toLowerCase().trim()
    if (!slug || slug === 'geral') {
      setExibirOleosResultado(false)
      sessionStorage.setItem('exibir_oleos_resultado', '0')
      return
    }
    let ativo = true
    void (async () => {
      try {
        const resp = await lumi.entities.consultoras.list({
          filter: { usuario: slug },
          limit: 1,
        })
        if (!ativo) return
        const consultoraObj = resp?.list?.[0]
        const exibir = consultoraObj?.exibirOleosResultado === true || consultoraObj?.exibirOleosResultado === 'true'
        setExibirOleosResultado(exibir)
        sessionStorage.setItem('exibir_oleos_resultado', exibir ? '1' : '0')
      } catch (err) {
        console.error('[home2] erro ao carregar configuracao da consultora', err)
        if (ativo) {
          setExibirOleosResultado(false)
          sessionStorage.setItem('exibir_oleos_resultado', '0')
        }
      }
    })()
    return () => {
      ativo = false
    }
  }, [cParam])

  // Resolver consultora do ?c= diretamente (igual ao Diagnóstico Kids)
  const consultora = (cParam || 'geral').toLowerCase().trim()

  // Enquanto não há ?c=, não renderiza nada (o redirect já foi disparado)
  if (!cParam) return null

  return (
    <div className="min-h-screen bg-bege-fundo flex items-center justify-center px-4 py-10">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="max-w-2xl w-full text-center"
      >
        {/* Bloco de apresentação da consultora */}
        <div className="text-left">
          <BlocoApresentacaoConsultora consultora={consultora} modo="intro" />
        </div>

        <div className="inline-block bg-verde-claro text-white px-4 py-2 rounded-full text-xs sm:text-sm font-dm-sans font-medium mb-6">
          Diagnóstico Personalizado
        </div>

        <h1 className="text-3xl sm:text-5xl md:text-6xl font-cormorant font-semibold text-texto-escuro mb-6 leading-tight">
          {exibirOleosResultado
            ? 'Descubra o que está afetando sua energia, emoções e bem-estar'
            : 'Descubra quais óleos essenciais o seu corpo e mente precisam.'}
        </h1>

        <p className="text-base sm:text-lg text-texto-suave mb-10 sm:mb-12 leading-relaxed">
          {exibirOleosResultado ? (
            <>
              Receba uma orientação para seus desconfortos e saiba como equilibrar sua saúde de forma natural.<br />Responda com sinceridade.<br />Cada pergunta revela um caminho.
            </>
          ) : (
            'Ao final você descobre o que está desequilibrado em sua saúde física e emocional e recebe orientação para cuidar de você de forma natural.'
          )}
        </p>

        <div className="space-y-4 mb-10 sm:mb-12">
          <div className="flex items-center gap-3 text-left">
            <div className="w-10 h-10 rounded-full bg-verde-claro flex items-center justify-center flex-shrink-0">
              <CheckCircle className="w-5 h-5 text-white" />
            </div>
            <p className="text-sm sm:text-base text-texto-escuro">20 perguntas sobre saúde física e emocional</p>
          </div>

          <div className="flex items-center gap-3 text-left">
            <div className="w-10 h-10 rounded-full bg-verde-claro flex items-center justify-center flex-shrink-0">
              <CheckCircle className="w-5 h-5 text-white" />
            </div>
            <p className="text-sm sm:text-base text-texto-escuro">
              {exibirOleosResultado ? 'Resultado personalizado ao final' : 'Resultado individual ao final'}
            </p>
          </div>

          <div className="flex items-center gap-3 text-left">
            <div className="w-10 h-10 rounded-full bg-verde-claro flex items-center justify-center flex-shrink-0">
              <CheckCircle className="w-5 h-5 text-white" />
            </div>
            <p className="text-sm sm:text-base text-texto-escuro">Leva cerca de 5 minutos</p>
          </div>
        </div>

        <button
          onClick={() => {
            sessionStorage.setItem('diagnostico_start', 'lead')
            const params = new URLSearchParams(searchParams)
            if (consultora && consultora !== 'geral') {
              params.set('c', consultora)
            }
            const qs = params.toString()
            navigate(qs ? `/resultado?${qs}` : '/resultado')
          }}
          className="w-full sm:w-auto min-h-[48px] bg-verde-escuro text-white px-8 py-4 rounded-full text-base sm:text-lg font-dm-sans font-medium hover:bg-opacity-90 transition-all shadow-lg hover:shadow-xl"
        >
          Começar meu diagnóstico →
        </button>
      </motion.div>
      <AvisoCookiesMonica slug={cParam} pagina="home-diagnostico" />
    </div>
  )
}

export default Home2
